import { IdenfyLivenessCheckResult } from '@tf/shared';
import { Stack, TFLoadingOverlay, Title } from '@tf/ui';
import { getObjectDisplayName } from '@tf/utils';
import { CaseRequest, CaseToolbar } from '@/components/shared';
import { useCaseWithRequests } from '@/core/api/caseRequests';
import { useLivenessCheck } from '@/core/api/livenessCheck';
import { useAccountParams } from '@/core/hooks';

export const ProfileCaseRoute = () => {
	const { caseId } = useAccountParams();

	const { data: caseWithRequests, isSuccess } = useCaseWithRequests(caseId);

	if (!isSuccess) {
		return <TFLoadingOverlay h={300} label="Case loading..." />;
	}

	return (
		<Stack mt="0.75rem" gap="0.75rem">
			<Title order={3}>Case {getObjectDisplayName(caseWithRequests.case.aliases)}</Title>
			<CaseToolbar caseWithRequests={caseWithRequests} />
			{caseWithRequests.requests.map((request) => {
				const livenessCheckId = caseWithRequests.case.data.liveness_check?._object;
				return (
					<CaseRequest
						key={request.id}
						caseRequest={request}
						caseData={caseWithRequests.case}
						livenessCheckResults={livenessCheckId ? <LivenessCheckResults livenessCheckId={livenessCheckId} /> : null}
					/>
				);
			})}
		</Stack>
	);
};

const LivenessCheckResults = ({ livenessCheckId }: { livenessCheckId: string }) => {
	const livenessCheck = useLivenessCheck(livenessCheckId);

	if (!livenessCheck.data) {
		return null;
	}

	return (
		<IdenfyLivenessCheckResult
			state={livenessCheck.data.meta.state}
			response={livenessCheck.data.data.response}
			attachments={livenessCheck.data.attachments.map((a) => a.object)}
		/>
	);
};
